export default __webpack_public_path__ + "static/media/apoie_1600.8860f6b7.webp";